import { useState } from "react";
import { toast } from "react-toastify";
import { Stack, Typography } from "@mui/material";
import { useRestoreDemoCampaignMutation } from "../../../../api";
import { CustomButton } from "../../CustomButton";
import { ClockWithArrowIcon } from "components/images";
import { ReuseModal } from "../../ReuseModal";
import { CustomToast } from "../../CustomToast";
import { getErrorMessage } from "../../../../utils/getErrorMessage";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "../../../../types/enums";

export const RestoreCampaignBtn = ({
  campaign_id,
}: {
  campaign_id: string;
}) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const [restoreCampaign, { isLoading }] = useRestoreDemoCampaignMutation();

  const resetCampaignHandler = () => {
    restoreCampaign(campaign_id)
      .unwrap()
      .then(({ id }) => {
        toast.success(
          <CustomToast
            type={"success"}
            text={"All campaign information was successfully restored"}
            title={"Campaign Restored"}
          />,
        );
        navigate(`${AppRoutes.CAMPAINGS}/${id}`, { replace: true });
        setIsOpen(false);
      })
      .catch((error) => {
        toast.error(
          <CustomToast
            type={"error"}
            text={
              getErrorMessage(error).globalError ||
              "Something went wrong. Please try again"
            }
            title={"Something Went Wrong"}
          />,
        );
        setIsOpen(false);
      });
  };

  return (
    <>
      <CustomButton
        onClick={() => setIsOpen(true)}
        variant="contained"
        fullWidth
        textColor="#FFFFFF"
        customColor="#C0392B"
        type="button"
        startIcon={<ClockWithArrowIcon />}
        sx={{ height: "38px" }}
      >
        Restore Campaign
      </CustomButton>

      <ReuseModal
        icon="warn"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSubmit={resetCampaignHandler}
        title="Restore Campaign"
        customText={
          <Stack gap="36px">
            <Typography variant="body1" color="text.secondary">
              Are you sure you want to restore the demo campaign?
            </Typography>
            <Typography variant="body1" color="text.secondary">
              This action will
              <strong>{" permanently erase "}</strong> all changes.
            </Typography>
          </Stack>
        }
        isDisabled={isLoading}
        isLoading={isLoading}
        submitBtnText="Restore"
        maxWidth="430px"
      />
    </>
  );
};
